import React from "react";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";
import JobShiftEmergencyProcedureHeader from "./JobShiftEmergencyProcedureHeader";
import JobShiftEmergencyProcedureTitleBand from "./JobShiftEmergencyProcedureTitleBand";
import EmergencyProcedureDetailsSection from "./sections/EmergencyProcedureDetailsSection";
import EmergencyProcedureDocumentAuthorization from "./sections/EmergencyProcedureDocumentAuthorization";
import ProcedureDynamicSections from "./sections/ProcedureDynamicSections";
import EmergencyProcedureRescueConfigurationAppendix from "./sections/EmergencyProcedureRescueConfigurationAppendix";

const getProcedureList = (procedures) => {
  const document = procedures && procedures.document && typeof procedures.document === "object"
    ? procedures.document
    : procedures;
  const source = document && document.emergency_procedures
    ? document.emergency_procedures
    : document;
  const procedureList = Array.isArray(source && source.procedures)
    ? source.procedures
    : (Array.isArray(source) ? source : []);

  return procedureList.filter((procedure) => (
    procedure && (procedure.toggle === 1 || procedure.toggle === true || procedure.toggle === "1")
  ));
};

export { getProcedureList };

const getProcedureKey = (procedure, index) => `${procedure && (procedure.id || procedure.procedure_id || procedure.document_number || index)}`;
const getAnchor = (procedureKey, suffix) => `emergency-procedure-${procedureKey}-${suffix}`;

export default function JobShiftEmergencyProceduresDocument({ procedures, sections, context, embedded = false, withNavigationAnchors = false }) {
  const procedureList = getProcedureList(procedures);

  const content = (
    <main>
        <div style={{ background: "transparent" }}>
          {procedureList.map((procedure, index) => (
            <div
              key={getProcedureKey(procedure, index)}
              className={styles.PreviewDoc}
              style={{
                minHeight: "180px",
                marginBottom: index === procedureList.length - 1 ? 0 : "24px"
              }}
            >
              <JobShiftEmergencyProcedureHeader procedure={procedure} sections={sections} context={context} />
              <JobShiftEmergencyProcedureTitleBand procedure={procedure} />
              <div id={withNavigationAnchors ? getAnchor(getProcedureKey(procedure, index), "details") : undefined} style={withNavigationAnchors ? { scrollMarginTop: "140px" } : undefined}>
                <EmergencyProcedureDetailsSection procedure={procedure} sections={sections} context={context} />
              </div>
              <div id={withNavigationAnchors ? getAnchor(getProcedureKey(procedure, index), "authorization") : undefined} style={withNavigationAnchors ? { scrollMarginTop: "140px" } : undefined}>
                <EmergencyProcedureDocumentAuthorization procedure={procedure} sections={sections} />
              </div>
              <ProcedureDynamicSections
                procedure={procedure}
                swmsSections={sections}
                withNavigationAnchors={withNavigationAnchors}
                procedureKey={getProcedureKey(procedure, index)}
              />
              {Array.isArray(procedure.sections) ? procedure.sections
                .filter((section) => section && section.type === "rescue_configuration_media" && section.data && section.data.toggle === 1)
                .map((section) => (
                  <EmergencyProcedureRescueConfigurationAppendix key={section.id} section={section} sections={sections} />
                )) : null}
            </div>
          ))}
        </div>
      </main>
  );

  return embedded ? content : <div className={styles.PreviewWrap}>{content}</div>;
}
